<template>
    <v-dialog-old @hidden="cancel" :onCloseEsc="closeModal" ref="dialog" class="glue" :special-styles="{ width: '1800px' }">
        <v-dialog-old @hidden="closeModal" :onCloseEsc="closeModal" ref="successDialog" class="glue">
            Проверка {{ parserName }} запущена
            <footer>
                <button @click="closeModal" class="green btn-norm" type="submit">OK</button>
            </footer>
        </v-dialog-old>

        <fieldset>
            <legend>
                <span>Парсер {{ parserName }}</span>
            </legend>

            <label>URLs с разделителями: пробел, перенос или запятая</label>

            <textarea v-model="urls"/>

            <footer>
                <v-loading-component @click="submit">
                    <template slot-scope="{ loadingClass }">
                        <button :class="[loadingClass]" :disabled="processing">Все</button>
                    </template>
                </v-loading-component>

                <v-loading-component @click="e => submit(e, true)">
                    <template slot-scope="{ loadingClass }">
                        <button :class="[loadingClass]" :disabled="processing || !urls.trim()">Список URL</button>
                    </template>
                </v-loading-component>
            </footer>
        </fieldset>
    </v-dialog-old>
</template>

<script>
export default {
    data: () => ({
        urls: '',
        parser: null,
        parserName: null,
        processing: false,
    }),
    methods: {
        show(parser, parserName) {
            this.parser = parser;
            this.parserName = parserName;
            this.$refs.dialog.show()
        },
        cancel() {
            this.urls = '';
            this.parser = null;
            this.parserName = null;
            this.processing = false;
        },
        closeModal() {
            this.cancel()
            this.$refs.dialog.hide()
        },
        submit(btn, onlyChosenUrls = false) {
            if (onlyChosenUrls && !this.urls.trim()) {
                return;
            }

            btn.startLoadingAnimation();

            let urls = null;
            if (onlyChosenUrls) {
                urls = this.urls;
            }

            this.processing = true;
            this.axios.post('checks/launchParser/' + this.parser, {
                urls: urls,
            }).then((response) => {
                this.$refs.successDialog.show();
                this.processing = false;
                btn.stopLoadingAnimation();
                this.$emit('disableBnt', this.parser);
            }).catch((error) => {
                this.processing = false;
                btn.stopLoadingAnimation();
            })
        },
    },
}
</script>
